import { userManagementService } from "../request";

/**
 * 获取子部门列表
 * @param {Object} params 查询参数 {page, size, name?}
 * @returns {Promise} 返回Promise对象
 */
export const getSubDepartments = (params) => {
  return userManagementService.get("/sub-departments", { params });
};

/**
 * 获取所有子部门
 * @returns {Promise} 返回Promise对象
 */
export const getAllSubDepartments = () => {
  return userManagementService.get("/sub-departments/all");
};

/**
 * 创建子部门
 * @param {Object} data 子部门数据
 * @returns {Promise} 返回Promise对象
 */
export const createSubDepartment = (data) => {
  return userManagementService.post("/sub-departments", data);
};

/**
 * 更新子部门信息
 * @param {String} id 子部门ID
 * @param {Object} data 更新数据
 * @returns {Promise} 返回Promise对象
 */
export const updateSubDepartment = (id, data) => {
  return userManagementService.put(`/sub-departments/${id}`, data);
};

/**
 * 删除子部门
 * @param {String} id 子部门ID
 * @returns {Promise} 返回Promise对象
 */
export const deleteSubDepartment = (id) => {
  return userManagementService.delete(`/sub-departments/${id}`);
};

/**
 * 获取子部门详情
 * @param {String} id 子部门ID
 * @returns {Promise} 返回Promise对象
 */
export const getSubDepartmentById = (id) => {
  return userManagementService.get(`/sub-departments/${id}`);
}; 